import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Box, Container } from '@mui/material';
import { colors } from '../utils/colors';
import { trackCTAWithAttribution } from '../utils/utmTracking';

function HeroSection() {
  const { t, i18n } = useTranslation();
  return (
    <Box
      id="home"
      sx={{
        backgroundColor: colors.yellow,
        py: 8,
        textAlign: 'center',
        borderBottom: `2px solid ${colors.red}`,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            fontWeight: 'bold',
            color: colors.darkRed,
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' },
            lineHeight: 1.4,
          }}
        >
          {i18n.language === 'en' && (
            <>
              <div style={{ fontFamily: 'Exo, sans-serif', fontSize: '1.2em' }}>
                Whenever in doubt,
              </div>
              <div style={{ fontFamily: 'Exo, sans-serif', fontSize: '1.2em' }}>
                check <span style={{ fontFamily: 'TanAshford, serif', fontSize: '0.833em' }}>Ulpian</span>
              </div>
            </>
          )}
          {i18n.language === 'hr' && (
            <>
              <div style={{ fontFamily: 'Exo, sans-serif', fontSize: '1.2em' }}>
                Imaš pravo,
              </div>
              <div style={{ fontFamily: 'Exo, sans-serif', fontSize: '1.2em' }}>
                imaš <span style={{ fontFamily: 'TanAshford, serif', fontSize: '0.833em' }}>Ulpian</span>
              </div>
            </>
          )}
          {(i18n.language === 'es' || i18n.language === 'de') && (
            <div style={{ fontFamily: 'Exo, sans-serif', fontSize: '1.2em' }}>
              {t('hero.title').split('Ulpian').map((part, index, array) => (
                <React.Fragment key={index}>
                  {part}
                  {index < array.length - 1 && (
                    <span style={{ fontFamily: 'TanAshford, serif', fontSize: '0.833em' }}>Ulpian</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </Box>
        <Typography variant="h6" sx={{ color: colors.darkRed, mb: 4, mt: 2 }}>
          {t('hero.subtitle')}
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={() => {
              trackCTAWithAttribution('request_access', 'hero_section');
              const element = document.getElementById('try');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            sx={{
              backgroundColor: colors.red,
              color: colors.yellow,
              fontWeight: 'bold',
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              '&:hover': { backgroundColor: colors.darkRed },
            }}
          >
            {t('hero.get_started')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default HeroSection;
